import React, { useCallback, useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import SideBanner from "components/layout/SideBanner";
import BillingData from "./BillingData";
import Meter from "./Meter";
import PersonalData from "./PersonalData";
import Registration from "./Registration";
import { Body, Container, Content } from "./styles";
import SuccessRegister from "./SuccessRegister";
import ValidateRegistration from "./ValidateRegistration";

const Adesao = ({ step, document, phoneDdd, phoneNumber }) => {
  const history = useHistory();

  const [steppers] = useState([
    "Identificação",
    "Dados Cadastrais",
    "Cadastre sua residência ou loja",
    "Medidor",
    "Dados de Cobrança",
    "Cadastro de senha",
    "Conclusão"
  ]);

  const phoneNumberMasked = useCallback(() => {
    if (phoneDdd && phoneNumber) {
      const masked = phoneNumber.replace(phoneNumber.slice(0, 5), "*****");
      return phoneDdd + masked;
    }
    return "";
  }, [phoneDdd, phoneNumber]);

  const buildComponente = useCallback(step => {
    step = step === 1 ? 2 : step;
    return (
      {
        1: () => <></>,
        2: <PersonalData />,
        3: <Registration />,
        4: <Meter />,
        5: <BillingData />,
        6: <ValidateRegistration />,
        7: <SuccessRegister />
      }[step] || <Registration />
    );
  }, []);

  const buildHeader = useCallback(
    step => {
      step = step === 1 ? 2 : step;

      return (
        {
          1: { h1: "", h2: "" },
          2: {
            h1: "Dados cadastrais",
            h2: "Agora informe seus dados pessoais",
          },
          3: {
            h1: "Cadastre sua residência ou loja",
            h2: "Digite o CEP ou o código do condomínio",
          },
          4: {
            h1: "Possui medidor?",
            h2: "Verifique o exemplo a seguir",
          },
          5: {
            h1: "Dados da cobrança",
            h2: "Cadastre com apenas alguns cliques a melhor opção para o recebimento de suas faturas.",
          },
          5.1: {
            h1:
              "Entre em contato com a Unidade de Atendimento Cliente em caso de emancipação",
            h2: ""
          },
          6: {
            h1: "Cadastro de senha",
            h2: "Estamos quase lá! Escolha uma senha.",
          },
          7: {
            h1: "Tudo certo!!",
            h2: "Agora você já pode acessar seu portal e visualizar todas as suas unidades em um único lugar.",
          }
        }[step] || { h1: "", h2: "" }
      );
    },
    [phoneDdd, phoneNumber]
  );

  useEffect(() => {
    if (!document) {
      history.push("/");
    }
  }, [document]);

  return (
    <Container>
      <SideBanner
        activated={step}
        header={buildHeader(step)}
        steppers={steppers}
      />
      <Content>
        <Body>{buildComponente(step)}</Body>
      </Content>
    </Container>
  );
};

const mapStateToProps = state => ({
  step: state.membershipReducer.step,
  document: state.membershipReducer.document,
  phoneDdd: state.membershipReducer.phoneDdd,
  phoneNumber: state.membershipReducer.phoneNumber
});

export default connect(mapStateToProps)(Adesao);
